import React from 'react';
import { ResponsiveContainer, PieChart, Pie, Tooltip, Legend, Cell } from 'recharts';
import { THEME } from '../constants';
import PropTypes from 'prop-types';

const PICK_COLORS = {
    favorite: '#82ca9d',    // Green for favorites
    underdog: '#8884d8',    // Purple for underdogs
    pickem: '#ffc658',      // Yellow for pick'ems
    over: '#ff8042',        // Orange for overs
    under: '#0088fe',       // Blue for unders
    no_pick: '#dc3545',     // Red for no picks
    bye: '#999999'          // Gray for byes
};

const PickDistributionChart = ({ data }) => {
    if (!data) return null;

    console.log('Raw Pick Distribution Data:', data);

    // Process the data to combine home/away into favorites/underdogs/pickems
    const processedData = data.reduce((acc, item) => {
        let category = item.pick_type;
        let count = item.count;

        const existingCategory = acc.find(entry => entry.name === category);
        if (existingCategory) {
            existingCategory.value += count;
        } else {
            acc.push({
                name: category,
                value: count,
                wins: item.wins || 0
            });
        }
        return acc;
    }, []);

    // Custom sort order for the pie segments
    const segmentOrder = ['favorite', 'pickem', 'underdog', 'over', 'under', 'bye', 'no_pick'];
    processedData.sort((a, b) => {
        return segmentOrder.indexOf(a.name) - segmentOrder.indexOf(b.name);
    });

    // Format display names
    const formatPickType = (type) => {
        switch (type) {
            case 'favorite': return 'Favorites';
            case 'underdog': return 'Underdogs';
            case 'pickem': return 'Pick\'ems';
            case 'over': return 'Overs';
            case 'under': return 'Unders';
            case 'no_pick': return 'No Picks';
            case 'bye': return 'Byes';
            default: return type;
        }
    };

    console.log('Processed Pick Distribution Data:', processedData);

    return (
        <div className="chart-container pick-distribution-chart">
            <h3>Pick Distribution</h3>
            <ResponsiveContainer width="100%" height={345}>
                <PieChart>
                    <Pie
                        data={processedData}
                        dataKey="value"
                        nameKey="name"
                        outerRadius={100}
                        innerRadius={0}
                        label={({ name, value, percent }) =>
                            `${formatPickType(name)} (${(percent * 100).toFixed(0)}%)`
                        }
                        labelLine={{
                            stroke: '#666',
                            strokeWidth: 1,
                            offsetRadius: 20
                        }}
                    >
                        {processedData.map((entry) => (
                            <Cell
                                key={entry.name}
                                fill={PICK_COLORS[entry.name] || '#999999'}
                            />
                        ))}
                    </Pie>
                    <Tooltip
                        formatter={(value, name, props) => [
                            //NOSONAR[javascript:S6774]
                            `${value} picks (${props.payload.wins} wins)`,
                            formatPickType(name)
                        ]}
                        contentStyle={{
                            backgroundColor: THEME.colors.background,
                            border: `1px solid ${THEME.colors.grid}`,
                            color: '#ffffff'
                        }}
                        labelStyle={{ color: '#ffffff' }}
                        itemStyle={{ color: '#ffffff' }}
                    />
                    <Legend
                        formatter={(value) => formatPickType(value)}
                    />
                </PieChart>
            </ResponsiveContainer>
        </div>
    );
};

PickDistributionChart.propTypes = {
    data: PropTypes.arrayOf(PropTypes.shape({
        pick_type: PropTypes.string.isRequired,
        count: PropTypes.number.isRequired,
        wins: PropTypes.number
    }))
};

export default PickDistributionChart;
